export default "__VITE_ASSET__BMMOAIc5__"